import React, { forwardRef } from 'react'
import { Select } from 'antd'
import { useTranslation } from 'lib/i18n'

import useRequestOccasions from 'hooks/useRequestOccasions'

const { Option } = Select

const RequestOccasionSelect = (props, ref) => {
  const { productType, ...rest } = props
  const { t } = useTranslation()
  const {
    loading,
    error,
    requestOccasions = [],
  } = useRequestOccasions({
    productType,
  })
  if (error) return <div>Error: {JSON.stringify(error, null, 2)}</div>

  return (
    <Select
      loading={loading}
      ref={ref}
      {...rest}
      placeholder={t(
        'RequestOccasionSelect.placeholder',
        'What is the occasion?',
      )}
      data-cy="occasionsList"
    >
      {requestOccasions.map((occ) => (
        <Option value={occ.id} key={occ.id}>
          {occ.title}
        </Option>
      ))}
    </Select>
  )
}

export default forwardRef(RequestOccasionSelect)
